import { createStyles, MantineTheme } from '@mantine/core';
import { CalloutType, CalloutVariant, isSubtle } from './types';

export interface CalloutStylesParams {
  type: CalloutType;
  variant: CalloutVariant;
}

const BORDER_COLORS = {
	success: 'green.2',
	info: 'navy.2',
	warning: 'orange.2',
	error: 'red.2',
	promotional: 'blue.3'
};

const BACKGROUND_COLORS = {
	success: 'green.0',
	info: 'navy.0',
	warning: 'orange.0',
	error: 'red.0',
	promotional: 'blue.0'
};

const ICON_COLORS = {
	success: 'green.5',
	info: 'navy.5',
	warning: 'orange.5',
	error: 'red.5',
	promotional: 'blue.5'
};

const borderColorForType = ( theme: MantineTheme, type: CalloutType ): string => (
	theme.fn.themeColor( BORDER_COLORS[ type ] || BORDER_COLORS.info )
);
const backgroundColorForType = ( theme: MantineTheme, type: CalloutType ): string => (
	theme.fn.themeColor( BACKGROUND_COLORS[ type ] || BACKGROUND_COLORS.info )
);

const iconColorForType = ( theme: MantineTheme, type: CalloutType ): string => (
	theme.fn.themeColor( ICON_COLORS[ type ] || ICON_COLORS.info )
);

export default createStyles( ( theme, { type, variant }: CalloutStylesParams ) => ( {
	root: {
		...( !isSubtle( variant ) ? {
			border: `1px solid ${borderColorForType( theme, type )}`,
			borderRadius: '4px'
		} : {} ),
		background: backgroundColorForType( theme, type )
	},
	icon: { marginTop: '2px', color: iconColorForType( theme, type ) },
	title: { color: '#1C1D24' },
	text: { color: '#1C1D24' }
} ) );
